import React from 'react'
import { useHistory } from 'react-router-dom'

import { Container } from './styles'

import Title from '../../Components/Title'
import Button from '../../Components/Button'

export default function InfeccoesGenitaisPage(){
    const history = useHistory()
    return (
        <Container>
            <Title>Infecções Genitais</Title>

            <Button onClick={() => {
                history.push("infeccoesGenitais/informacoes")
            }}>Informações</Button>
            <Button onClick={() => {
                history.push("infeccoesGenitais/pep")
            }}>Profilaxia Pós-Exposição</Button>

            <Button onClick={() => {
                history.push("infeccoesGenitais/medicamentosAdulto")
            }}>Medicamentos</Button>
            <Button onClick={() => {
                history.push("infeccoesGenitais/seguimentoLaboratorial")
            }}>Seguimento Laboratorial</Button>
        </Container>
    )
}